import { render, staticRenderFns } from "./ordermanagementdispose.vue?vue&type=template&id=1ed1ac34&"
import script from "./ordermanagementdispose.vue?vue&type=script&lang=ts&"
export * from "./ordermanagementdispose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ordermanagementdispose.vue"
export default component.exports